var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-2",
    transform: "translate(-588.686 -2143)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(588.686 2143)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5589",
    "data-name": "Trac\\xE9 5589",
    d: "M.672,0h5.94V-1.8H2.964C3.024-2.9,6.48-3.42,6.48-6.1A2.677,2.677,0,0,0,3.552-8.724,3.309,3.309,0,0,0,.528-6.876l1.56,1.044s.456-.912,1.272-.912a.848.848,0,0,1,.924.852c0,1.236-3.708,1.8-3.708,4.968A5.257,5.257,0,0,0,.672,0Z",
    transform: "translate(592.603 2154.586)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation2);
export default __webpack_public_path__ + "static/media/location-2.ba91f586a6267b3cbc5f3175d7d7b39b.svg";
export { ForwardRef as ReactComponent };